// src/index.js
import React from 'react';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';

// React 18 API
import { createRoot } from 'react-dom/client';
// React 17 fallback
import ReactDOM from 'react-dom';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element with id="root" not found in public/index.html');
}

const appTree = (
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// Use React 18 if available; otherwise fall back to React 17 render
if (typeof createRoot === 'function') {
  const root = createRoot(container);
  root.render(appTree);
} else {
  ReactDOM.render(appTree, container);
}
